import { Injectable } from '@angular/core';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
    public list: {
        [key: string]: MdbPopoverDirective
    } = {};

    constructor() {
    }

}
